var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"s-back-top hv-highlight",style:({width: _vm.width, height: _vm.height}),attrs:{"src":_vm.src,"alt":""},on:{"click":function($event){return _vm.scrollTo(0)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }